import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import outletIcon from './icon.svg';
import styles from './DropdownOutlet.css';
import tickedOutlet from './ticked-outlet.svg';

class Toggle extends React.Component {
  render() {
    const { outletName, withCaret } = this.props;
    return (
      <div className={styles.dropdown}>
        <button
          type="button"
          onClick={this._onClick}
          className={`btn btn-default ${styles['button-toggle']}`}
        >
          <div className={styles['outlet-name-wrapper']}>
            <img
              alt="Outlet icon"
              className={styles['outlet-icon']}
              src={outletIcon}
            />
            {outletName}
          </div>
          {withCaret && <span className="caret" />}
        </button>
      </div>
    );
  }

  _onClick = e => {
    e.preventDefault();
    this.props.onClick(e);
  };
}

class DropdownOutlet extends React.Component {
  render() {
    const { outlets, allOutletOption, input } = this.props;
    const { value } = input;

    const allOutlet = {
      id: outlets.map(outlet => outlet.id),
      name: 'All Outlets',
    };

    const loadingOutlet = {
      id: [],
      name: 'Loading...',
    };
    let activeOutlet = { id: [], name: '' };

    if (value.length > 1) {
      activeOutlet = allOutlet;
    } else if (value.length === 1) {
      outlets.forEach(outlet => {
        if (outlet.id === value[0] && value.length === 1) {
          activeOutlet = {
            id: [outlet.id],
            name: useMokaOutletPropsFirst(outlet, o => o.name),
          };
        }
      });
    } else {
      activeOutlet = loadingOutlet;
    }

    if (outlets.length > 1) {
      return (
        <Dropdown id="dropdown-custom-1">
          <Toggle
            outletName={activeOutlet.name}
            bsRole="toggle"
            onClick={this._onClickToggle}
            withCaret={outlets.length > 1}
          />
          <Dropdown.Menu className={styles.menu} bsRole="menu">
            {allOutletOption && outlets.length > 1 && (
              <MenuItem
                onSelect={this._onSelect}
                eventKey={allOutlet.id}
                className={styles['menu-item']}
              >
                {/* <a className={styles['menu-item']}> */}
                <span>
                  {activeOutlet.id.length > 1 && (
                    <img
                      alt="Ticked outlet"
                      className={styles['list-outlet-selected-icon']}
                      src={tickedOutlet}
                    />
                  )}
                </span>
                <span className={styles['list-outlet-name']}>
                  {allOutlet.name}
                </span>
                {/* </a> */}
              </MenuItem>
            )}
            {outlets.map(outlet => {
              const outletIds = [outlet.id];
              return (
                <MenuItem
                  onSelect={this._onSelect}
                  eventKey={outletIds}
                  className={styles['menu-item']}
                  key={outlet.id}
                >
                  {outlet.id === activeOutlet.id[0] &&
                    activeOutlet.id.length === 1 && (
                      <span>
                        <img
                          alt="Ticked outlet"
                          className={styles['list-outlet-selected-icon']}
                          src={tickedOutlet}
                        />
                      </span>
                    )}
                  <span className={styles['list-outlet-name']}>
                    {useMokaOutletPropsFirst(outlet, o => o.name)}
                  </span>
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return (
      <button
        type="button"
        className={`btn btn-default ${styles['button-toggle']}`}
        disabled
      >
        <div className={styles['outlet-name-wrapper']}>
          <img
            alt="Outlet icon"
            className={styles['outlet-icon']}
            src={outletIcon}
          />
          {activeOutlet.name}
        </div>
      </button>
    );
  }

  _onSelect = outletIds => {
    this.props.onChangeOutletIds(outletIds);
  };

  _onClickToggle = () => {};
}

DropdownOutlet.propTypes = {
  outlets: PropTypes.array,
  name: PropTypes.string,
  allOutletOption: PropTypes.bool,
};

export default DropdownOutlet;
